import { Type } from "@scalar/typebox";
const XCodeSampleSchema = Type.Object({
  lang: Type.Optional(Type.String()),
  label: Type.Optional(Type.String()),
  source: Type.String()
});
const XCodeSamplesSchema = Type.Object({
  "x-codeSamples": Type.Optional(Type.Array(XCodeSampleSchema)),
  "x-code-samples": Type.Optional(Type.Array(XCodeSampleSchema)),
  "x-custom-examples": Type.Optional(Type.Array(XCodeSampleSchema))
});
export {
  XCodeSampleSchema,
  XCodeSamplesSchema
};
//# sourceMappingURL=x-code-samples.js.map
